import React from 'react';
import ReactDOM from 'react-dom';
import { SharingIndicator } from './sharing-indicator.jsx';

export default angular
  .module('doxy.videoChat.callFrames.sharingIndicator', [])
  .component('sharingIndicator', {
    template: `<div class="sharing-indicator"></div>`,
    bindings: {
      onStop: '&',
    },
    controller: function ($element, $translate) {
      const render = () => {
        ReactDOM.render(
          React.createElement(SharingIndicator, {
            spanText: $translate.instant('video-chat.actions.you-are-sharing'),
            btnText: $translate.instant('video-chat.actions.stop-sharing'),
            onStopClick: this.onStop,
          }),
          $element[0]
        );
      };
      this.$onChanges = render;
    },
  }).name;
